import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { dayColor, makeRowColumn } from 'lib/commonLib';
import {
  appTargetingDailyStatistics,
  appTargetingDailyGraph,
} from 'lib/api/datacenter';

import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import BarGraph from 'components/organisms/Chart/BarGraph';
import NewCommonFilter from 'components/organisms/NewCommonFilter';

const AppTargetingDailyStatistics = ({ extraCustomized }) => {
  const { t } = useTranslation();
  let initParams = {
    sDate: moment().add(-30, 'day').format('YYYYMMDD'),
    eDate: moment().format('YYYYMMDD'),
    sort: 'desc',
    order: 'STATS_DTTM',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [reGetData, setReGetData] = useState(false);

  const graphList = [
    {
      title: t('지출금액'),
      data: { bar: ['ADVRTS_AMT'] },
      yAxisData: {
        left: { ADVRTS_AMT: true },
        right: {},
      },
    },
    {
      title: t('노출'),
      data: { bar: ['PAR_EPRS_CNT'] },
      yAxisData: {
        left: { PAR_EPRS_CNT: true },
        right: {},
      },
    },
    {
      title: t('클릭률'),
      data: { bar: ['CLICK_RATE'] },
      yAxisData: {
        left: { CLICK_RATE: true },
        right: {},
      },
      customizeData: {
        CLICK_RATE: {
          tooltipFormat: '0.000',
          isPercent: true,
        },
      },
    },
  ];

  useEffect(() => {
    if (reGetData === true) {
      setReGetData(false);
    }
  }, [reGetData]);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeBody: (rowObj, headsMap) => {
        return rowObj['STATS_DTTM'] !== 'total'
          ? dayColor(makeRowColumn(rowObj['STATS_DTTM']))
          : rowObj['STATS_DTTM'];
      },
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setParams(initParams);
      setInitialization(true);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
      </NewFilterWrap>
      <BarGraph
        params={params}
        dataReqPromise={appTargetingDailyGraph}
        graphList={graphList}
        title={t('일자별통계')}
        labelType="MMDD"
      />
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={appTargetingDailyStatistics}
        customized={{ ...extraCustomized, ...customized }}
        useFetch={false}
        useSearch={false}
        borderRangeStart={8}
        borderRangeEnd={10}
      />
    </>
  );
};

export default AppTargetingDailyStatistics;
